export const authenticationSelector = state => state.common.authentication

export const isAuthenticatedSelector = state =>
  authenticationSelector(state).authenticated

export const permissionsSelector = state =>
  authenticationSelector(state).permissions



// WEBPACK FOOTER //
// ./src/redux/selectors/authSelector.js